import _ from 'lodash';

export function isPayed(unt) {
    const PAYED_UNT_LIST = _.chain(this.$store.getters['menu/menuGroups'])
        .filter(['isPayed', true])
        .map('unt')
        .value();
    return PAYED_UNT_LIST.includes(unt);
}

export function isAuth(unt) {
    // admin
    if (unt === 'admin') {
        return this.$store.getters['account/isAdmin'];
    }
    // ahoo agent
    if (unt === 'ahoo-agent') {
        return this.$store.getters['account/isAhooAgent'];
    }
    // other
    const userAuthList = this.$store.getters['account/untList'];
    return userAuthList.includes(unt);
}

export function isAuthAll(untList) {
    for (let i = 0; i < untList.length; i += 1) {
        const unt = untList[i];
        if (!this.isAuth(unt)) {
            return false;
        }
    }
    return true;
}

export function isAuthOne(untList) {
    for (let i = 0; i < untList.length; i += 1) {
        const unt = untList[i];
        if (this.isAuth(unt)) {
            return true;
        }
    }
    return false;
}

export function scrollToBottom(element) {
    const el = element;
    el.scrollTop = element.scrollHeight - element.clientHeight;
}

export function scrollToId(id, position = 'center') {
    setTimeout(() => {
        document.getElementById(id).scrollIntoView({
            block: position,
            behavior: 'smooth',
        });
    }, 100);
}

// 個資保護
export function protectedInfo(text, method, amount, fromEnd) {
    if (!text) return text;
    if (text === '') return text;

    if (method === 'get') {
        const returnValue = [];
        const ORIGINAL = fromEnd ? text.split('').reverse() : text.split('');
        ORIGINAL.forEach((ele, i) => {
            if (i < amount || (!fromEnd && ORIGINAL.length > 2 && i === ORIGINAL.length - 1)) returnValue.push(ele); // 輸入為兩字元以上，最後一個字不遮蔽
            else returnValue.push('〇');
        });
        return fromEnd ? returnValue.reverse().join('') : returnValue.join('');
    }

    if (method === 'cover') {
        const returnValue = [];
        const ORIGINAL = fromEnd ? text.split('').reverse() : text.split('');
        ORIGINAL.forEach((ele, i) => {
            if (i < amount) returnValue.push('〇');
            else returnValue.push(ele);
        });
        return fromEnd ? returnValue.reverse().join('') : returnValue.join('');
    }

    if (method.includes('split')) {
        const splitSymbol = method.split('-')[1];
        const returnValue = [];
        const ORIGINAL = fromEnd ? text.split('').reverse() : text.split('');
        const splitSymbolIndex = ORIGINAL.findIndex((o) => o === splitSymbol);

        ORIGINAL.forEach((ele, i) => {
            if (i < splitSymbolIndex) returnValue.push('〇');
            else returnValue.push(ele);
        });
        return fromEnd ? returnValue.reverse().join('') : returnValue.join('');
    }

    console.log('not support method: ', method);
    return text;
}

// 是否為唯讀查詢帳號 (GRP_NO === 'QR')，僅能查詢資料，不可執行任何異動操作
export function isQR() {
    return this.$store.getters['account/isQR'];
}

export function isMobile() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
    }
    return false;
}
